import { useEffect, useState } from "react"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"
import { getCssDemention } from "src/libs/utilities/getCssDemention"
import { ALIGN, ContactsContent, ILandingSection } from "src/modules/pe-landing-module/data/interfaces"
import MenuPrimitive from "../primitive/MenuPrimitive"
import Dummy from "./Dummy"
import { ContactsPrimitive } from "../primitive"
import DataContentEditor from "../landing-edit/editors/data-content-editor"


/* Protopia Ecosystem component */
export interface IPEWidgetProps {
    section: ILandingSection
    data: ContactsContent
}
const Contacts = ({data, ...props}: IPEWidgetProps): JSX.Element => {
    const [marginLeft]    = useState<string>(!![ALIGN.END, ALIGN.MIDDLE ].find(e => e === data.horizontal_align)  || !data.horizontal_align ? "auto" : "0")
    const [marginRight]   = useState<string>(!![ALIGN.START, ALIGN.MIDDLE ].find(e => e === data.horizontal_align) || !data.horizontal_align ? "auto" : "0")
    const [marginTop]     = useState<string>(!![ALIGN.END, ALIGN.MIDDLE ].find(e => e === data.vertical_align) || !data.vertical_align ? "auto" : "0")
    const [marginBottom]  = useState<string>(!![ALIGN.START, ALIGN.MIDDLE ].find(e => e === data.vertical_align) || !data.vertical_align ? "auto" : "0")
    const [width]         = useState<string>(getCssDemention( data.width,  "inherit" ))
    const [height, ]      = useState<string>(getCssDemention( data.height, "inherit" )) 

    useEffect(() => {
        addCSSClass(
            `landing-contacts-${props.section.id}`,
            `.landing-contacts-${props.section.id} {
                margin-left: ${marginLeft};
                margin-right: ${marginRight};
                margin-top: ${marginTop};
                margin-bottom: ${marginBottom};
                max-width: ${ width };
                max-height: ${ height };
                width: ${ width };
                height: ${ height };
                z-index:1;
            } 
            `
        )           
        return () => {
            removeCSSClass(`landing-contacts-${props.section.id}`)
        }
    },[ ]) 
    
    return <div className='pe-contacts-container landing-content-container' data-type={data.type} data-content-id={data.id}>
        {
            !!data.items?.length
                ?
                <div className={`landing-menu landing-contacts-${props.section.id} ${ data.className || "" } `} style={ data.style || {} }>
                    <ContactsPrimitive  
                        primitive={{
                            ...(data )
                        } as any }  
                    /> 
                </div>
                :
                <Dummy {...{ 
                    data: {...data, className: `landing-contacts-${props.section.id}`}, 
                    ...props 
                }} />
        }
        <DataContentEditor data={data}  section={props.section} />       
    </div>
}
export default Contacts

 